import { ChangeEvent, useState } from "react";
import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { DateType } from "../../../../static/types/commonTypes/dateType";
import DateComponent from "../../../commonComponents/DateComponent";
import Manager from "../../../commonComponents/Manager";
import { initialManagerState } from "../../../../static/types/objectInitialState";
import ReducedManager from "../../../commonComponents/ReducedManager";
import { initialReducedManagerState } from "../../../../static/initialState/commonInitialState/initialReducedManagerState";

interface ChangeAuditorProps {
    societyType: string [];
}
const ChangeAuditor:React.FC<ChangeAuditorProps> = ({
    societyType
}) => {

    const {

        auditorChangeEffectiveDate,
        setAuditorChangeEffectiveDate,
        setAuditorChangeEffectiveDateValidity,
        auditorChangeEffectiveDateChecked,

        auditorChange, setAuditorChange,

        newStatutoryAuditor, setNewStatutoryAuditor,
        setNewStatutoryAuditorValidity,
        newStatutoryAuditorChecked, setNewStatutoryAuditorChecked,

        newAlternateAuditor, setNewAlternateAuditor,
        setNewAlternateAuditorValidity,
        newAlternateAuditorChecked, setNewAlternateAuditorChecked,
        typeNewAlternateAuditorData, setTypeNewAlternateAuditorData,

        formerStatutoryAuditor, setFormerStatutoryAuditor,
        setFormerStatutoryAuditorValidity,
        formerStatutoryAuditorChecked, setFormerStatutoryAuditorChecked,

        formerAlternateAuditor, setFormerAlternateAuditor,
        setFormerAlternateAuditorValidity, 
        formerAlternateAuditorChecked, setFormerAlternateAuditorChecked, 
        typeFormerAlternateAuditorData, setTypeFormerAlternateAuditorData,
        
    } = useAppContext() as AppContextType

    const handleToggleAuditorsChange = ( event: ChangeEvent<HTMLSelectElement> ) => {
        
        setAuditorChange(Number(event.target.value))

        setNewStatutoryAuditor (initialManagerState)
        setNewStatutoryAuditorValidity (false)
        setNewStatutoryAuditorChecked (false)
    
        setNewAlternateAuditor (initialManagerState)
        setNewAlternateAuditorValidity (false)
        setNewAlternateAuditorChecked (false)
        setTypeNewAlternateAuditorData (0)
    
        setFormerStatutoryAuditor (initialReducedManagerState)
        setFormerStatutoryAuditorValidity (false)
        setFormerStatutoryAuditorChecked (false)
    
        setFormerAlternateAuditor (initialReducedManagerState)
        setFormerAlternateAuditorValidity (false)
        setFormerAlternateAuditorChecked (false)
        setTypeFormerAlternateAuditorData (0)
    }

    const updateDate = (data: Partial<DateType>) => setAuditorChangeEffectiveDate ({...auditorChangeEffectiveDate, ...data});
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    
    return (
        <div>
            <div className = 'col-sm-10 d-flex align-items-center mt-1'>
                <label htmlFor = "modification" className = "col-sm-2 col-form-label mb-0">
                    Modification
                </label>
                <select
                    className = 'form-select w-75'
                    id = 'person'
                    onChange = { handleToggleAuditorsChange }
                    value =  { auditorChange }
                >
                    <option value = { 0 }> Aucune modification </option>
                    <option value = { 1 }> Nomination </option>
                    <option value = { 2 }> Départ sans remplacement </option>
                    <option value = { 3 }> Départ avec remplacement du titulaire </option>
                    <option value = { 4 }> Départ avec remplacement du suppléant </option>
                    <option value = { 5 }> Départ avec remplacement du titulaire et suppléant </option>
                </select>
            </div>
            {
                ( ![ 0, 2 ].includes(auditorChange)) &&
                    <div className = "mt-3 col-sm-7">
                        <DateComponent
                            id="auditorChangeEffectiveDate"
                            date = { auditorChangeEffectiveDate }
                            draftFieldName = 'auditorChangeEffectiveDate'
                            changeDate = { updateDate }
                            dateLabel = "Date d'effet"
                            checked = { auditorChangeEffectiveDateChecked }
                            onValidationChange = {( isValid: boolean ) => setAuditorChangeEffectiveDateValidity( isValid )}
                            required = { false }
                        />
                    </div>
            }

            {
                auditorChange === 1 &&
                    <div>
                        <div className = 'mt-3'>
                            <h6 className = 'text-bold'>
                                Commissaire aux comptes titulaire
                            </h6>
                            <Manager
                                manager = { newStatutoryAuditor }
                                setManager = { setNewStatutoryAuditor }
                                checked = { newStatutoryAuditorChecked }
                                setChecked = { setNewStatutoryAuditorChecked }
                                societyType = { societyTypeOptions }
                                updateManagerValidity = {( isValid: boolean ) => setNewStatutoryAuditorValidity ( isValid )}
                                draftFieldName = "newStatutoryAuditor"
                            />
                        </div>
                        <div className = 'row align-items-center mt-3'>
                            <h6 className = 'text-bold'>
                                Commissaire aux comptes suppléant
                            </h6>
                            <div className = "col-sm-10">
                                <select
                                    className = "form-select w-25"
                                    id = "person"
                                    onChange = {( event ) => {
                                        setNewAlternateAuditor( initialManagerState )
                                        setTypeNewAlternateAuditorData( Number( event.target.value ))
                                    }}
                                    value = { typeNewAlternateAuditorData }
                                >
                                    <option value = { 1 }> Oui </option>
                                    <option value = { 0 }> Non </option>
                                </select>
                            </div>
                            {
                                typeNewAlternateAuditorData === 1 &&
                                    <div>
                                        <div className = 'mt-3'>
                                            <Manager
                                                manager = { newAlternateAuditor }
                                                checked = { newAlternateAuditorChecked }
                                                setChecked = { setNewAlternateAuditorChecked }
                                                setManager = { setNewAlternateAuditor }
                                                societyType = { societyTypeOptions }
                                                updateManagerValidity = {( isValid: boolean ) => setNewAlternateAuditorValidity ( isValid )}
                                                draftFieldName = "newAlternateAuditor"
                                            />
                                        </div>
                                    </div>
                                
                            }
                            
                        </div>
                    </div>
            }

            {
                auditorChange === 2 &&
                    <div>
                        <div className = 'mt-3'>
                            <h6 className = 'text-bold'>
                                Commissaire aux comptes titulaire
                            </h6>
                                <ReducedManager
                                    checked = { formerStatutoryAuditorChecked }
                                    manager = { formerStatutoryAuditor }
                                    draftFieldName = "formerStatutoryAuditor"
                                    setChecked = { setFormerStatutoryAuditorChecked }
                                    setManager = { setFormerStatutoryAuditor }
                                    updateManagerValidity = {( isValid ) => setFormerStatutoryAuditorValidity ( isValid )}
                                />
                        </div>
                        <div className = 'row align-items-center mt-3'>
                            <h6 className = 'text-bold'>
                                Commissaire aux comptes suppléant
                            </h6>
                            <div className = "col-sm-10">
                                <select
                                    className = "form-select w-25"
                                    id = "person"
                                    onChange = {( event ) => {
                                        setFormerAlternateAuditor( initialReducedManagerState )
                                        setTypeFormerAlternateAuditorData( Number( event.target.value ))
                                    }}
                                    value = { typeFormerAlternateAuditorData }
                                >
                                        <option value = { 1 }> Oui </option>
                                        <option value = { 0 }> Non </option>
                                </select>
                            </div>
                            {
                                typeFormerAlternateAuditorData === 1 &&
                                <div>
                                    <div className = 'mt-3'>
                                        <ReducedManager
                                            manager = { formerAlternateAuditor }
                                            draftFieldName = "formerAlternateAuditor"
                                            setManager = { setFormerAlternateAuditor }
                                            setChecked = { setFormerAlternateAuditorChecked }
                                            checked = { formerAlternateAuditorChecked }
                                            updateManagerValidity = {( isValid ) => setFormerAlternateAuditorValidity ( isValid )}
                                        />
                                    </div>
                            </div>
                            }
                        </div>
                    </div>
            }

            {
                auditorChange === 3 &&
                    <div>
                        <div className = 'mt-3'>
                            <h6 className = 'text-bold'>
                                Nouveau commissaire aux comptes titulaire
                            </h6>
                            <Manager
                                manager = { newStatutoryAuditor }
                                setManager = { setNewStatutoryAuditor }
                                checked = { newStatutoryAuditorChecked }
                                setChecked = { setNewStatutoryAuditorChecked }
                                societyType = { societyTypeOptions }
                                updateManagerValidity = {( isValid: boolean ) => setNewStatutoryAuditorValidity ( isValid )}
                                draftFieldName = "newStatutoryAuditor"
                            />
                        </div>
                        <div className = 'mt-3'>
                            <h6 className = 'text-bold'>
                                Ancien commissaire aux comptes titulaire
                            </h6>
                            <ReducedManager
                                checked = { formerStatutoryAuditorChecked }
                                manager = { formerStatutoryAuditor }
                                draftFieldName = "formerStatutoryAuditor"
                                setChecked = { setFormerStatutoryAuditorChecked }
                                setManager = { setFormerStatutoryAuditor }
                                updateManagerValidity = {( isValid ) => setFormerStatutoryAuditorValidity ( isValid )}
                            />
                        </div>
                    </div>
            }

            {
                auditorChange === 4 &&
                    <div>
                        <div className = "mt-3 row">
                            <h6 className = 'text-bold'>
                                Nouveau commissaire aux comptes suppléant
                            </h6>
                            <label htmlFor = "personne" className = "col-sm-2 col-form-label">
                                Saisir données
                            </label>
                            <div className = "col-sm-10">
                                <select
                                    className = "form-select w-25"
                                    id = "person"
                                    onChange = {(e) => {
                                        setNewAlternateAuditor( initialManagerState )
                                        setTypeNewAlternateAuditorData( Number( e.target.value ))
                                    }}
                                    value = { typeNewAlternateAuditorData }
                                >
                                    <option value = { 1 }> Oui </option>
                                    <option value = { 0 }> Non </option>
                                </select>
                            </div>
                            {
                                typeNewAlternateAuditorData === 1 &&
                                <div className = 'mt-3'>
                                    <Manager
                                        manager = { newAlternateAuditor }
                                        checked = { newAlternateAuditorChecked }
                                        setChecked = { setNewAlternateAuditorChecked }
                                        setManager = { setNewAlternateAuditor }
                                        societyType = { societyTypeOptions }
                                        updateManagerValidity = {( isValid: boolean ) => setNewAlternateAuditorValidity ( isValid )}
                                        draftFieldName = "newAlternateAuditor"
                                    />
                                </div>
                            }
                        </div>
                        <div className = "mt-3 row">
                            <h6 className = 'text-bold'>
                                Ancien commissaire aux comptes suppléant
                            </h6>
                            <label htmlFor = "personne" className = "col-sm-2 col-form-label">
                                Saisir données
                            </label>
                            <div className = "col-sm-10">
                                <select
                                    className = "form-select w-25"
                                    id = "person"
                                    onChange = {( event ) => {
                                        setFormerAlternateAuditor( initialReducedManagerState )
                                        setTypeFormerAlternateAuditorData(Number(event.target.value))
                                    }}
                                    value = { typeFormerAlternateAuditorData }
                                >
                                    <option value = { 1 }> Oui </option>
                                    <option value = { 0 }> Non </option>
                                </select>
                            </div>
                            {
                                typeFormerAlternateAuditorData === 1 &&
                                <div className = 'mt-3'>
                                    <ReducedManager
                                        manager = { formerAlternateAuditor }
                                        draftFieldName = "formerAlternateAuditor"
                                        setManager = { setFormerAlternateAuditor }
                                        setChecked = { setFormerAlternateAuditorChecked }
                                        checked = { formerAlternateAuditorChecked }
                                        updateManagerValidity = {( isValid ) => setFormerAlternateAuditorValidity ( isValid )}
                                    />
                                </div>
                            }
                        </div>
                    </div>
            }

            {
                auditorChange === 5 &&
                    <div>
                        <div className = 'mt-3'>
                            <h6 className = 'text-bold'>
                                Nouveau commissaire aux comptes titulaire
                            </h6>
                            <Manager
                                manager = { newStatutoryAuditor }
                                setManager = { setNewStatutoryAuditor }
                                checked = { newStatutoryAuditorChecked }
                                setChecked = { setNewStatutoryAuditorChecked }
                                societyType = { societyTypeOptions }
                                updateManagerValidity = {( isValid: boolean ) => setNewStatutoryAuditorValidity ( isValid )}
                                draftFieldName = "newStatutoryAuditor"
                            />
                        </div>
                        <div className = 'mt-3'>
                            <h6 className = 'text-bold'>
                                Ancien commissaire aux comptes titulaire
                            </h6>
                            <ReducedManager
                                checked = { formerStatutoryAuditorChecked }
                                manager = { formerStatutoryAuditor }
                                draftFieldName = "formerStatutoryAuditor"
                                setChecked = { setFormerStatutoryAuditorChecked }
                                setManager = { setFormerStatutoryAuditor }
                                updateManagerValidity = {( isValid ) => setFormerStatutoryAuditorValidity ( isValid )}
                            />
                        </div>
                        <div className = "mt-3 row">
                            <h6 className = 'text-bold'>
                                Nouveau commissaire aux comptes suppléant
                            </h6>
                            <label htmlFor = "personne" className = "col-sm-2 col-form-label">
                                Saisir données
                            </label>
                            <div className = "col-sm-10">
                                <select
                                    className = "form-select w-25"
                                    id = "person"
                                    onChange = {(e) => {
                                        setNewAlternateAuditor( initialManagerState )
                                        setTypeNewAlternateAuditorData( Number( e.target.value ))
                                    }}
                                    value = { typeNewAlternateAuditorData }
                                >
                                    <option value = { 1 }> Oui </option>
                                    <option value = { 0 }> Non </option>
                                </select>
                            </div>
                            {
                                typeNewAlternateAuditorData === 1 &&
                                <div className = 'mt-3'>
                                    <Manager
                                        manager = { newAlternateAuditor }
                                        checked = { newAlternateAuditorChecked }
                                        setChecked = { setNewAlternateAuditorChecked }
                                        setManager = { setNewAlternateAuditor }
                                        societyType = { societyTypeOptions }
                                        updateManagerValidity = {( isValid: boolean ) => setNewAlternateAuditorValidity ( isValid )}
                                        draftFieldName = "newAlternateAuditor"
                                    />
                                </div>
                            }
                        </div>
                        <div className = "mt-3 row">
                            <h6 className = 'text-bold'>
                                Ancien commissaire aux comptes suppléant
                            </h6>
                            <label htmlFor = "personne" className = "col-sm-2 col-form-label">
                                Saisir données
                            </label>
                            <div className = "col-sm-10">
                                <select
                                    className = "form-select w-25"
                                    id = "person"
                                    onChange = {( event ) => {
                                        setFormerAlternateAuditor( initialReducedManagerState )
                                        setTypeFormerAlternateAuditorData( Number( event.target.value ))
                                    }}
                                    value = { typeFormerAlternateAuditorData }
                                >
                                    <option value = { 1 }> Oui </option>
                                    <option value = { 0 }> Non </option>
                                </select>
                            </div>
                            {
                                typeFormerAlternateAuditorData === 1 &&
                                <div className = 'mt-3'>
                                    <ReducedManager
                                        manager = { formerAlternateAuditor }
                                        draftFieldName = "formerAlternateAuditor"
                                        setManager = { setFormerAlternateAuditor }
                                        setChecked = { setFormerAlternateAuditorChecked }
                                        checked = { formerAlternateAuditorChecked }
                                        updateManagerValidity = {( isValid ) => setFormerAlternateAuditorValidity ( isValid )}
                                    />
                                </div>
                            }
                        </div>
                    </div>
            }
        </div>
    );
}
export default ChangeAuditor;